import { useFlags } from "launchdarkly-react-client-sdk"

const DEFAULT_MESSAGE =
  "We are currently experiencing technical difficulties. We apologize for any inconvenience caused and are actively working to resolve the issue."

export default function OutageBanner() {
  const { customOutageBanner } = useFlags()

  if (!customOutageBanner || customOutageBanner === "disabled") {
    return null
  }

  return (
    <section className="fixed top-0 left-0 z-[400] text-sm text-center py-1 w-full bg-red-500 text-white flex items-center justify-center gap-1">
      <i className="ri-error-warning-fill text-base" />
      {customOutageBanner ?? DEFAULT_MESSAGE}
    </section>
  )
}
